import React from 'react'
import Home from './pages/home'

export default function App() {
  return (
    <>
      <Home />
    </>
  )
}
